import { useEffect, useRef, useState } from "react";
import { formatTrNumber } from "@/lib/motion";

export const Reveal = ({ enabled, children, className = "" }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!enabled || !ref.current) return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        setShown(true);
        io.disconnect();
      }
    }, { rootMargin: "0px 0px -10% 0px" });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [enabled]);
  if (!enabled) return children;
  return <div ref={ref} className={`reveal ${shown ? "is-visible" : ""} ${className}`}>{children}</div>;
};

export const TiltCard = ({ enabled, children }) => {
  const ref = useRef(null);
  const fine = typeof window !== "undefined" && window.matchMedia?.("(pointer: fine)").matches;
  if (!enabled || !fine) return children;
  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    ref.current.style.transform = `perspective(900px) rotateX(${(-y * 6).toFixed(2)}deg) rotateY(${(x * 6).toFixed(2)}deg)`;
  };
  const leave = () => { ref.current.style.transform = ""; };
  return <div ref={ref} className="tilt-card" onPointerMove={move} onPointerLeave={leave}>{children}</div>;
};

const CountUp = ({ to }) => {
  const ref = useRef(null);
  const [val, setVal] = useState(0);
  useEffect(() => {
    let raf;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const start = performance.now();
      const step = (t) => {
        const k = Math.min(1, (t - start) / 1200);
        setVal(to * (1 - (1 - k) ** 3));
        if (k < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    });
    io.observe(ref.current);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [to]);
  return <span ref={ref}>{formatTrNumber(val)}</span>;
};

const STAT_LABELS = ["Otogar alanı", "Arsa alanı", "Peron", "Yazıhane"];
const NUM = /^([\d.]+)\s*(m²|çift)?$/;

export const TerminalStats = ({ facts }) => {
  const stats = STAT_LABELS.map((l) => facts.find((f) => f.label === l && NUM.test(f.value))).filter(Boolean).slice(0, 2);
  if (!stats.length) return null;
  return (
    <dl className="mt-4 grid grid-cols-2 gap-3 border-t border-line pt-4" data-testid="terminal-card-stats">
      {stats.map((f) => {
        const [, num, unit] = f.value.match(NUM);
        return (
          <div key={f.label}>
            <dt className="text-xs font-semibold uppercase tracking-wide text-ink-muted">{f.label}</dt>
            <dd className="font-display text-xl font-bold text-navy">
              <span className="sr-only">{f.value}</span>
              <span aria-hidden="true"><CountUp to={Number(num.replace(/\./g, ""))} />{unit ? ` ${unit}` : ""}</span>
            </dd>
          </div>
        );
      })}
    </dl>
  );
};
